import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo, useMemo } from 'react';
import isEqual from 'react-fast-compare';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogsForFollowedSellers } from '@/redux/modules/filteredItems';
import { getFollowedSellerIds } from '@/redux/modules/followSeller';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getAuctionCalendarUrlWithParams } from '@/utils/urls';

import CarouselLoadingWrapper from '../CarouselLoadingWrapper/CarouselLoadingWrapper';
import { CatalogCard } from '../CatalogCard/CatalogCard';

type Props = {
    className?: string;
};

const AuctionsYouMayLikeCarouselComponent = ({ className }: Props) => {
    const formatMessage = useAppFormatMessage();
    const followedSellerIds = useAppSelector(getFollowedSellerIds, isEqual);
    const catalogIds = useAppSelector(getCatalogsForFollowedSellers);

    const catalogCards = useMemo(
        () =>
            catalogIds.map((catalogId) => ({
                card: (
                    <div
                        className="w-[285px] focus:outline-none [&_.featuredCardClass]:block [&_.featuredCardClass]:max-w-full"
                        key={`${catalogId}-youmay-like`}
                    >
                        <CatalogCard catalogId={catalogId} />
                    </div>
                ),
                key: `${catalogId}-youmay-like`,
            })),
        [catalogIds]
    );

    if (catalogIds.length < 4) {
        return null;
    }

    return (
        <div className={cn('flex flex-col', className)}>
            <div className="relative w-full max-w-[1240px] self-center p-0 text-center">
                <CarouselLoadingWrapper>
                    <Carousel
                        action={{
                            path: getAuctionCalendarUrlWithParams({
                                house_id: followedSellerIds,
                            }),
                            text: String(formatMessage(['see_all'])),
                        }}
                        cards={catalogCards}
                        title={String(formatMessage(['auctions_you_may_like']))}
                    />
                </CarouselLoadingWrapper>
            </div>
        </div>
    );
};

export const AuctionsYouMayLikeCarousel = memo<Props>(AuctionsYouMayLikeCarouselComponent);
